import { useState } from 'react';
import { Link } from 'react-router-dom';
import ServicesPostventaLogo from '../../images/ServicesPostventaLogo.svg';
import ServicesPostventaLogoMobile from '../../images/ServicesPostventaLogoMobile.svg';
import out from '../../images/Navbar/out.svg';
import iconuser from '../../images/Navbar/user.svg';

export const NavBar = ({ user, displayName, onButtonClick }) => {
  const [isOpen, setIsOpen] = useState(false);

  if (!user) return null;

  return (
    <nav className="bg-white w-full sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          <div className="flex-shrink-0 flex items-center">
            <Link to="/home">
              <picture>
                <source srcSet={ServicesPostventaLogo} media="(min-width: 768px)" />
                <source srcSet={ServicesPostventaLogoMobile} media="(max-width: 767px)" />
                <img src={ServicesPostventaLogoMobile} alt="Logo Peabody" className="h-8 w-auto md:h-10" />
              </picture>
            </Link>
          </div>

          <div className="hidden md:flex flex-1" />

          <div className="hidden md:flex items-center space-x-4">
            <Link
              to="/perfil"
              className="group inline-flex items-center gap-2 bg-gradient-to-r from-peabodyBlue to-peabodyDark text-white px-4 py-2 rounded-xl text-sm font-semibold shadow-md shadow-peabodyBlue/30 transition-all duration-300 transform hover:-translate-y-0.5 hover:shadow-lg hover:shadow-peabodyBlue/50"
            >
              <img src={iconuser} className="h-4 w-4 brightness-0 invert transition-transform duration-300 group-hover:scale-110" alt="Icono usuario" />
              <span className="max-w-[140px] truncate">{displayName}</span>
            </Link>
            <button onClick={onButtonClick} className="p-2 rounded-full hover:bg-gray-100 transition-colors" title="Cerrar sesión">
              <img src={out} className="h-6 w-6" alt="Icono cerrar sesión" />
            </button>
          </div>

          <div className="flex items-center md:hidden">
            <button
              onClick={() => setIsOpen(!isOpen)}
              className="inline-flex items-center justify-center p-2 rounded-md text-gray-400 hover:text-peabodyBlue hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-peabodyBlue transition-colors"
            >
              <span className="sr-only">Abrir menú principal</span>
              {isOpen ? (
                <svg className="block h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              ) : (
                <svg className="block h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                </svg>
              )}
            </button>
          </div>
        </div>
      </div>

      <div className={`md:hidden overflow-hidden transition-all duration-300 ease-in-out ${isOpen ? 'max-h-72 opacity-100' : 'max-h-0 opacity-0'}`}>
        <div className="bg-white border-t border-gray-100 shadow-inner">
          <div className="pt-4 pb-3 border-t border-gray-200">
            <div className="flex items-center px-5 justify-between">
              <Link
                to="/perfil"
                onClick={() => setIsOpen(false)}
                className="group inline-flex items-center gap-2 bg-gradient-to-r from-peabodyBlue to-peabodyDark text-white px-4 py-2 rounded-xl text-sm font-semibold shadow-md shadow-peabodyBlue/30 transition-all duration-300 transform active:scale-[0.98]"
              >
                <img src={iconuser} className="h-4 w-4 brightness-0 invert transition-transform duration-300 group-hover:scale-110" alt="Icono usuario" />
                <span className="max-w-[140px] truncate">{displayName}</span>
              </Link>
              <button
                onClick={() => {
                  setIsOpen(false);
                  onButtonClick();
                }}
                className="flex items-center justify-center p-2 rounded-full hover:bg-red-50 text-red-600 transition-colors"
                title="Cerrar sesión"
              >
                <img src={out} className="h-6 w-6" alt="Icono cerrar sesión" />
              </button>
            </div>
          </div>
        </div>
      </div>
    </nav>
  );
};
